import React from "react";
import { chunk, isEmpty } from "lodash-es";
import { PriceChangePercentage } from "../Chat/Cards/type";
import PriceChangeItem from "../PriceChangeItem";
import { useIsPc } from "@/src/hooks";

/**
 * 价格涨跌表组件
 * 遵循OpenSocial UI设计规范，展示加密货币价格变化数据
 */
const DetailPriceChange: React.FC<{
  dataList: PriceChangePercentage[];
  className?: string;
}> = ({ dataList = [], className }) => {
  const [isPC] = useIsPc();
  // 使用传入的数据或默认数据
  const tableData = dataList?.length > 0 ? dataList : [];
  if (isEmpty(tableData)) {
    return null;
  }

  const rendeTable = (tableData: PriceChangePercentage[], index: number) => {
    return (
      <div
        className={`w-full flex flex-row items-center gap-[2px] ${className || ""}`}
        key={index}
      >
        {tableData.map((item, index) => {
          return <PriceChangeItem key={index} item={item} index={index} />;
        })}
      </div>
    );
  };

  if (isPC) {
    return rendeTable(tableData, 0);
  }

  const h5DataList = chunk(tableData || [], 3) || [];

  return (
    <div className="w-full gap-0.5 flex flex-col">
      {h5DataList.map((itemList: PriceChangePercentage[], index: number) => {
        return rendeTable(itemList, index);
      })}
    </div>
  );
};

export default DetailPriceChange;
